export default __webpack_public_path__ + "static/cro-ae435fb177f1d7a1aadb00d7d20a6838.gif";